export { updateCounterViews } from "./updateCounterViews";